// Golden scissors "snip" loader — Onda's branded wait state. Two blades
// oscillate around the pivot in opposite phase, like scissors cutting.
export default function GoldenScissors({ size = 'md', text = '', className = '' }) {
  const sizes = {
    sm: 20,
    md: 40,
    lg: 64,
  };
  const px = sizes[size] || sizes.md;

  return (
    <span className={`inline-flex flex-col items-center gap-2 ${className}`}>
      <svg
        width={px}
        height={px}
        viewBox="0 0 48 48"
        fill="none"
        aria-label="Loading"
        role="status"
      >
        <defs>
          <linearGradient id="goldenScissorsGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="hsl(30, 100%, 70%)" />
            <stop offset="100%" stopColor="hsl(30, 80%, 55%)" />
          </linearGradient>
        </defs>
        {/* top blade + handle */}
        <g style={{ transformOrigin: '20px 24px', animation: 'onda-snip-a 0.7s ease-in-out infinite' }}>
          <path d="M20 24 L44 14" stroke="url(#goldenScissorsGrad)" strokeWidth="3" strokeLinecap="round" />
          <circle cx="12" cy="15" r="5" stroke="url(#goldenScissorsGrad)" strokeWidth="3" />
          <path d="M16 18 L20 24" stroke="url(#goldenScissorsGrad)" strokeWidth="3" strokeLinecap="round" />
        </g>
        {/* bottom blade + handle */}
        <g style={{ transformOrigin: '20px 24px', animation: 'onda-snip-b 0.7s ease-in-out infinite' }}>
          <path d="M20 24 L44 34" stroke="url(#goldenScissorsGrad)" strokeWidth="3" strokeLinecap="round" />
          <circle cx="12" cy="33" r="5" stroke="url(#goldenScissorsGrad)" strokeWidth="3" />
          <path d="M16 30 L20 24" stroke="url(#goldenScissorsGrad)" strokeWidth="3" strokeLinecap="round" />
        </g>
        {/* pivot */}
        <circle cx="20" cy="24" r="2" fill="url(#goldenScissorsGrad)" />
      </svg>
      {text && <span className="text-sm text-muted-foreground animate-pulse">{text}</span>}
    </span>
  );
}
